namespace TabAurous.Production {
    export namespace MFGTransactionLossService {
        export const baseUrl = 'Production/MFGTransactionLoss';

        export declare function Create(request: Serenity.SaveRequest<MFGTransactionLossRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MFGTransactionLossRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MFGTransactionLossRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MFGTransactionLossRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Production/MFGTransactionLoss/Create",
            Update = "Production/MFGTransactionLoss/Update",
            Delete = "Production/MFGTransactionLoss/Delete",
            Retrieve = "Production/MFGTransactionLoss/Retrieve",
            List = "Production/MFGTransactionLoss/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>MFGTransactionLossService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
